import './facility-subnav.scss';

const NAVBAR_HEIGHT = 60;

function getNavbarHeight() {
	const sticky = document.querySelector( '.js-headerSticky' );
	if ( sticky && sticky.offsetHeight > 0 ) {
		return sticky.offsetHeight;
	}
	const navbar = document.querySelector( '.tm-navbar' );
	return ( navbar && navbar.offsetHeight > 0 ) ? navbar.offsetHeight : NAVBAR_HEIGHT;
}

function initFacilitySubnav() {
	const nav = document.querySelector( '.js-facilitySubnav' );
	if ( ! nav ) {
		return;
	}

	const links = nav.querySelectorAll( '.js-facilitySubnavLink' );
	if ( ! links.length ) {
		return;
	}

	// Smooth scroll naar sectie, rekening houdend met navbar + subnav hoogte
	links.forEach( ( link ) => {
		link.addEventListener( 'click', ( e ) => {
			const targetId = link.dataset.target;
			const target = targetId ? document.getElementById( targetId ) : null;
			if ( ! target ) {
				return;
			}
			e.preventDefault();
			const navbarH = getNavbarHeight();
			const subnavH = nav.offsetHeight;
			const top = target.getBoundingClientRect().top + window.scrollY - navbarH - subnavH;
			window.scrollTo( { top, behavior: 'smooth' } );
		} );
	} );

	// Actieve link bijhouden via scroll
	const targets = Array.from( links )
		.map( ( link ) => document.getElementById( link.dataset.target ) )
		.filter( Boolean );

	if ( ! targets.length ) {
		return;
	}

	const setActive = ( id ) => {
		links.forEach( ( link ) => {
			link.classList.toggle( 'is-active', link.dataset.target === id );
		} );
	};

	const updateActive = () => {
		const navbarH = getNavbarHeight();
		const subnavH = nav.offsetHeight;
		const offset = navbarH + subnavH + 16;

		let activeId = null;
		targets.forEach( ( target ) => {
			if ( target.getBoundingClientRect().top <= offset ) {
				activeId = target.id;
			}
		} );

		if ( activeId ) {
			setActive( activeId );
		}
	};

	window.addEventListener( 'scroll', updateActive, { passive: true } );
	updateActive();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initFacilitySubnav );
} else {
	initFacilitySubnav();
}
